var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTooltip',[_c('img',{staticClass:"info-icon",attrs:{"slot":"trigger","src":"/img/icons/info.svg","width":"16","height":"16","alt":"Information"},slot:"trigger"}),_vm._t("default",null,{"slot":"popover"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }